export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard/analysis',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  // goAppExternal page path
  GOAPP_EXTERNAL = '/goAppExternal',
  // goAppExternal page path
  GOAPP_PERSON = '/shanshe2/index?tenantId=0&app=shanshe2',
}
